import { ReactNode } from 'react';
import Link from 'next/link';

type CommunityLink = {
  name: string;
  slug: string;
  onClick?: () => void;
  children?: ReactNode;
}

const CommunityLink = ({ name, slug, children, onClick }: CommunityLink) => {
  const linkToCommunity = `/${slug}`;
  const href = `/community/communityHome?slug=${slug}`;

  return (
    <Link as={linkToCommunity} href={href}>
      <a onClick={onClick}>
        {children || name}
      </a>
    </Link>
  );
};

export default CommunityLink;
